module.exports = __webpack_public_path__ + "static/threads-4f199b3b7f57369f0b9880797d625e46.webp";